import React from 'react';
import {FormattedMessage, IntlProvider} from 'react-intl';

import * as ResourceApi from 'api/resources';
import {enUSmessage} from 'i18n/en-US.js';
import {
    CustomHTMLHeadlineToolTip,
    CustomHTMLIntroToolTip,
    CustomHTMLCustomCodeToolTip,
    CustomHTMLCustomCssToolTip
} from 'components/break/tooltips/custom-html-tool-tips';

export default {
    subSection: true,
    resource: false,
    hideIfResourceIsNoU: false,
    showSection: (formProxy) => {
        return formProxy.currentResource.resourceId.type === ResourceApi.Types.CustomHtmlStep
    },

    fields: [
        {
            type: 'contenteditable',
            name: 'headline',
            required: true,
            // Headline is only allowed if there is more than one Custom HTML step
            showField: (proxy) => (proxy.currentResource.type === 'CUSTOM_HTML' && proxy.currentBaseResource.steps && proxy.currentBaseResource.steps.length > 1),
            linkedField: (formProxy) => ["title"],
            props: {
                labelKey: 'editbreak.steps.custom_html.headline',
                helpContent: <CustomHTMLHeadlineToolTip/>,
                helpHeader: <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'tooltips.break.custom_html.headline'}/></IntlProvider>
            }
        },
        {
            type: 'contenteditable',
            name: 'description',
            required: false,
            showField: (proxy) => (proxy.currentResource.type === 'CUSTOM_HTML'),
            props: {
              labelKey: 'editbreak.steps.custom_html.intro_copy',
              maxLength: 500,
              placeholderKey: 'editbreak.steps.custom_html.intro_copy.placeholder',
              validationRules: [
                  {
                      type: 'MarkupTextLimit',
                      params: {
                          limit: 500
                      }
                  }
              ],
              helpContent: <CustomHTMLIntroToolTip/>,
              helpHeader: <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'tooltips.break.custom_html.intro_copy'}/></IntlProvider>
            }
        },
        {
            type: 'textarea',
            name: 'customCss',
            showField: (proxy) => (proxy.currentResource.type === 'CUSTOM_HTML'),

            props: {
                labelKey: 'editbreak.steps.custom_html.custom_css',
                helpContent: <CustomHTMLCustomCssToolTip/>,
                helpHeader: <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'tooltips.break.custom_html.custom_css'}/></IntlProvider>
            }
        },
        {
            type: 'textarea',
            name: 'customHtml',
            showField: (proxy) => (proxy.currentResource.type === 'CUSTOM_HTML'),

            props: {
                labelKey: 'editbreak.steps.custom_html.custom_html',
                helpContent: <CustomHTMLCustomCodeToolTip/>,
                helpHeader: <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'tooltips.break.custom_html.custom_html'}/></IntlProvider>
            }
        }
    ]
}



// WEBPACK FOOTER //
// ./public/components/EditContent/configs/breaks/steps/custom-html.js